export default __webpack_public_path__ + "static/media/redfin-logo.07c8cde3.svg";